// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Eritrea from '../_raw/flag/icon_flag_eritrea.png';

export default () => <img src={Eritrea} alt="Eritrea" />;
